<template>
  <div class="SecurityCheck">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>
        安全检查
        <!-- {{areaProtoy.title}} -->
      </span>
      <span class="other more" @click="linkTo">
        历史
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container ub-ac">
      <div class="right-part">
        <div class="ub ub-ac">
          <div class="barEchars" ref="barEchars"></div>
          <div class="pieEcharts" ref="pieEcharts"></div>
        </div>
        <p class="ft-14 col-66 mar-t">
          <span class="col-b">注：</span>合格数+不合格数=安全检查完成数
        </p>
      </div>
      <div class="left-part ub-f1">
        <div class="content ub">
          <div class="contentInfo ub-f1">
            <div
              class="title ft16 col-33"
              @click="jumpMore"
            >{{securityObj.title?securityObj.title:'暂无安全检查'}}</div>
            <div class="ft12 ub info-item ft-14">
              <span class="col-66 line">检查时间：</span>
              <p
                class="ft-wet ub-f1 col-66"
                v-if="securityObj.startTime"
              >{{securityObj.startTime}}至{{securityObj.endTime}}</p>
            </div>
            <div class="ft12 ub info-item ft-14">
              <span class="col-66 line">检查范围：</span>
              <p class="ft-wet ub-f1 col-66" :title="adminTips">
                {{securityObj.cantonNames?securityObj.cantonNames:'-'}}
                <span v-if="adminTips">等</span>
              </p>
            </div>
          </div>
          <div ref="echarsDemo" class="echarsDemo"></div>
        </div>
        <div class="footer">
          <div class="ub ub-ac">
            <div class="ft12 footer-label">完成进度</div>
            <div class="ub-f1">
              <el-progress
                :stroke-width="14"
                :color="progressColor"
                :show-text="true"
                :text-inside="true"
                class="col-33"
                :percentage="securityObj.finish? parseFloat(securityObj.finish):0"
              ></el-progress>
            </div>
            <div class="footer-item col-66 ft12">
              <svg-icon style="color:#0f77f2;margin:0 2px" iconClass="finish"></svg-icon>
              小区总数{{securityObj.allCount?securityObj.allCount:0}}个，已完成
              <span
                class="col-gre"
              >{{securityObj.doneCount?securityObj.doneCount:0}}</span>个
            </div>
          </div>
          <div class="ub ub-ac">
            <div class="ft12 footer-label">检查进度</div>
            <div class="ub-f1">
              <el-progress
                :stroke-width="14"
                :show-text="true"
                :text-inside="true"
                class="col-33"
                :percentage="checkProgress"
              ></el-progress>
            </div>
            <div class="footer-item col-66 ft12">
              <svg-icon style="color:#0f77f2;margin:0 2px" iconClass="timer"></svg-icon>
              共{{securityObj.allDays?securityObj.allDays:0}}天,剩余
              <span
                class="col-red"
              >{{securityObj.leftDays?securityObj.leftDays:0}}</span>天
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SecurityCheckControllerSvr } from '@/service/SecurityCheckControllerSvr/SecurityCheckControllerSvr';
import { mapState } from 'vuex';
import { SecurityCheckAMatterController } from '@/service/SecurityCheckAMatterController/SecurityCheckAMatterController';

export default {
  components: {},
  props: { myprop: Boolean },
  data() {
    return {
      Position: '1',
      isActive: '1',
      areaProtoy: {},
      checkProgress: 0,
      securityObj: {
        leftDays: 0,
      },
      securityCheckControllerSvr: new SecurityCheckControllerSvr(),
      unSecurity: [], //未完成安全检查物业区域{value:45,name:'未完成'},{value:60,name:'未完成'},{value:10,name:'未完成'}
      unqSecurity: [], //不合格安全检查物业区域
      proSecurity: [], //合格安全检查物业区域
      doneSpecial: [], //参与专项检查物业区域
      PieCharData: [], //完成未完成饼图
      echarsDemoData:[],//完成未执行饼图
      adminTips: '',
      progressColor: '#7cc562',
      securitykeyId: '', //检查事项KEYID
      safetype: '', //检查事项类型
      screen: '',
      barLength: '',
      pieEchartsInstance: {},
      barEcharsInstance: {},
      echarsDemoInstance: {},
      observer:null
    };
  },
  computed: {
    ...mapState(['token']),
  },
  created() {
    this.securityCheckAMatterController = new SecurityCheckAMatterController();
    //获取当前分辨率
    this.initScreen();
  },
  mounted() {
    const that = this;
    this.securityCheckAMatterController
      .getNextSecurityCheck(this.token, 6)
      .then((res) => {
        res = res.reverse();
        let finish = 0;
        let allCount = 0;
        for (let i = 0; i < res.length; i++) {
          finish += parseInt(res[i].doneCount);
          allCount += parseInt(res[i].allCount);

          this.unSecurity.push({
            value: parseInt(res[i].allCount) - parseInt(res[i].doneCount),
            name: '未完成',
          });
          if (res[i].type === '1') {
            this.unqSecurity.push({
              value: parseInt(res[i].doneCount) - parseInt(res[i].proCount),
              name: '不合格',
            });
            this.proSecurity.push({
              value: parseInt(res[i].proCount),
              name: '合格',
            });
            this.doneSpecial.push({
              value: 0,
              name: '已完成专项检查',
            });
          } else {
            this.unqSecurity.push({
              value: 0,
              name: '不合格',
            });
            this.proSecurity.push({
              value: 0,
              name: '合格',
            });
            this.doneSpecial.push({
              value: parseInt(res[i].doneCount),
              name: '已完成专项检查',
            });
          }
        }
        this.PieCharData = [
          { value: finish, name: '完成' },
          { value: allCount - finish, name: '未完成' },
        ];
        this.barLength = res.length;
        this.getPieEchar(this.$refs.pieEcharts);
        this.getBarEchar(this.$refs.barEchars, this.barLength, this.screen);
      });
    this.securityCheckAMatterController
      .getDoingSecurityCheckTask(this.token)
      .then((res) => {
        this.securityObj = res;
        this.securitykeyId = res.keyId;
        this.safetype = res.paperType;
        this.securityObj.finish = parseFloat(
          this.securityObj.doneCount / this.securityObj.allCount * 100
        ).toFixed(1);
        if (
          this.securityObj.allCount === 0 ||
          this.securityObj.allCount === null ||
          this.securityObj.allCount === '' ||
          this.securityObj.allCount === undefined
        ) {
          this.securityObj.finish = 0;
        }
        if (
          parseInt(this.securityObj.leftDays) >= 0 &&
          parseInt(this.securityObj.allDays) >= 0
        ) {
          this.checkProgress = parseFloat(
            (
              100 -
              this.securityObj.leftDays / this.securityObj.allDays * 100
            ).toFixed(2)
          );
        } else {
          this.checkProgress = 0;
        }
        if (res && res.cantonNames) {
          if (res.cantonNames.length > 3) {
            this.adminTips = res.cantonNames.join(',');
            res.cantonNames.length = 3;
          }
          res.cantonNames = res.cantonNames.join(',');
        }
        this.echarsDemoData = [
          { value: res.doneCount, name: '完成' },
          {
            value: parseInt(res.allCount) - parseInt(res.doneCount),
            name: '未执行',
          },
        ];

        this.getEchar(this.$refs.echarsDemo);
      });
    const SecurityCheck = document.getElementsByClassName('SecurityCheck')?.[0];
    this.observer = new ResizeObserver(entries => {
      that.initScreen();
      that.getPieEchar(that.$refs.pieEcharts);
      that.getBarEchar(that.$refs.barEchars, that.barLength, that.screen);
      that.getEchar(that.$refs.echarsDemo);
    });
    this.observer.observe(SecurityCheck);
  },
  updated() {},
  destroyed(){
    this.observer.disconnect();
  },
  methods: {
    //鼠标移入移出
    change(value) {
      this.isActive = value;
    },
    linkTo() {
      this.$router.push({
        path: 'SafeProductionCheckList',
        query: { t: Date.now() },
      });
    },
    jumpMore() {
      this.$router.push({
        path: 'SafetyProductionTwoPage',
        query: {
          keyId: this.securityObj.keyId,
          type: this.securityObj.paperType,
          theme: this.securityObj.title,
        },
      });
    },
    //字符转译HTML
    getEchar(dom) {
      if (dom){
        let legendName = ['完成', '未执行'];
        let ChartTips = '';
        if (!legendName.length) {
          ChartTips = '暂无数据';
        }
        let tempChart = this.$echarts.getInstanceByDom(dom);
        if (tempChart != null) {
          this.echarsDemoInstance.dispose();
        }
        this.echarsDemoInstance = this.$echarts.init(dom);
        let option = {
          backgroundColor: '',
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {d}% <br/> {c}次',
          },
          grid: {
            center: ['50%', '0'],
          },
          graphic: {
            elements: [
              {
                type: 'text',
                style: {
                  text: ChartTips,
                  x: 100,
                  y: 100,
                  textAlign: 'center',
                  fill: '#333333',
                  font: '16px "MicrosoftYaHei", sans-serif ',
                },
                left: '34%',
                top: '35%',
              },
            ],
          },
          legend: {
            orient: 'vertical',
            x: 'center',
            bottom: 0,
            itemWidth: 10,
            itemHeight: 10,
            align: 'left',
            textStyle: {
              fontSize: 14,
              color: '#000',
            },
            data: this.echarsDemoData,
          },
          series: [
            {
              type: 'pie',
              radius: ['65%', '75%'],
              center: ['50%', '40%'],
              color: ['#0f77f2', '#ffb11a'],
              startAngle: 65, //起始角度
              data: this.echarsDemoData,
              label: {
                show: true,
                formatter: '{c}次',
                textStyle: {
                  fontSize: 12,
                },
                width:48,
                position: 'outside',
                emphasis: {
                  show: true,
                },
                
              },
              labelLayout: {
                align:'left'
              },
              labelLine: {
                normal: {
                  show: true,
                  length: 6,
                  length2:this.screen?6:3,
                },
              },
            },
          ],
        };
        option&&this.echarsDemoInstance.setOption(option);
        this.echarsDemoInstance.on('click', () => {
          this.$router.push({
            path: '/SafeProductionList',
            query: {
              Safetype: this.Safetype,
              keyId: this.securitykeyId,
            },
          });
        });
      }
    },
    getBarEchar(dom, time, screen) {
      if (dom){
        let tempChart = this.$echarts.getInstanceByDom(dom);
        if (tempChart != null) {
          this.barEcharsInstance.dispose();
        }
        this.barEcharsInstance = this.$echarts.init(dom);
        var xData = (function() {
          let data = [];
          let numEnum = {
            1: '一',
            2: '二',
            3: '三',
            4: '四',
            5: '五',
            6: '六',
            7: '七',
          };
          for (let i = time; i > 0; i--) {
            data.push('最近的第' + numEnum[i] + '次');
          }
          return data;
        })();
        let option = {
          backgroundColor: '',
          title: {
            text: '最近已结束的安全生产检查情况',
            subtext: '',
            top: '0',
            x: 'center',
            textStyle: {
              color: '#666',
              fontSize: '18',
              overflow:'break',
            },
            subtextStyle: {
              color: '#333',
              fontSize: '16',
            },
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
              textStyle: {
                color: '#fff',
              },
            },
          },
          grid: {
            borderWidth: 0,
            top: '25%',
            right: '5%',
            left: '40px',
            bottom: '15%',
            textStyle: {
              color: '#fff',
            },
          },
          legend: {
            top: '10%',
            textStyle: {
              color: '#90979c',
            },
            // padding:[0,0,0,0],
            itemWidth: (function ab() {
              if (screen) {
                return 25;
              } else {
                return 14;
              }
            })(),
            data: ['未完成', '不合格', '合格', '已完成专项检查'],
          },
          calculable: true,
          xAxis: [
            {
              type: 'category',
              axisLine: {
                lineStyle: {
                  color: '#90979c',
                },
                textStyle: {
                  fontSize: 12,
                  color: '#000',
                },
              },
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              splitArea: {
                show: false,
              },
              axisLabel: {
                interval: 0,
                formatter: function(value) {
                  var ret = ''; //拼接加\n返回的类目项
                  var maxLength = (function a() {
                    if (screen) {
                      return 4;
                    } else {
                      return 3;
                    }
                  })(); //每项显示文字个数
                  var valLength = value.length; //X轴类目项的文字个数
                  var rowN = Math.ceil(valLength / maxLength); //类目项需要换行的行数
                  if (rowN > 1) {
                    //如果类目项的文字大于3,
                    for (var i = 0; i < rowN; i++) {
                      var temp = ''; //每次截取的字符串
                      var start = i * maxLength; //开始截取的位置
                      var end = start + maxLength; //结束截取的位置
                      //这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                      temp = value.substring(start, end) + '\n';
                      ret += temp; //凭借最终的字符串
                    }
                    return ret;
                  } else {
                    return value;
                  }
                },
              },
              data: xData,
            },
          ],
          yAxis: [
            {
              type: 'value',
              splitLine: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#90979c',
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                interval: 0,
              },
              splitArea: {
                show: false,
              },
            },
          ],
          series: [
            {
              name: '合格',
              type: 'bar',
              stack: 'bar1',
              barMaxWidth: 25,
              z: 2,
              barGap: '-100%',
              itemStyle: {
                normal: {
                  color: '#7cc562',
                  // 'label': {
                  //     'show': true,
                  //     'textStyle': {
                  //         'color': '#333'
                  //     },
                  //     'position': 'insideTop',
                  //     formatter: function(p) {
                  //         return p.value > 0 ? p.value : '';
                  //     }
                  // }
                },
              },
              data: this.proSecurity,
            },
            {
              name: '不合格',
              type: 'bar',
              stack: 'bar1',
              barMaxWidth: 25,
              z: 1,
              barGap: '-100%',
              itemStyle: {
                normal: {
                  color: '#ee6260',
                  // 'label': {
                  //     'show': true,
                  //     'textStyle': {
                  //         'color': '#333'
                  //     },
                  //     'position': 'insideTop',
                  //     formatter: function(p) {
                  //         return p.value > 0 ? p.value : '';
                  //     }
                  // }
                },
              },
              data: this.unqSecurity,
            },
            {
              name: '未完成',
              type: 'bar',
              stack: 'bar1',
              z: 0,
              barMaxWidth: 25,
              barGap: '10%',
              itemStyle: {
                normal: {
                  color: '#cccccc',
                  // 'label': {
                  //     'show': true,
                  //     'textStyle': {
                  //         'color': '#333'
                  //     },
                  //     'position': 'insideTop',
                  //     formatter: function(p) {
                  //         return p.value > 0 ? p.value : '';
                  //     }
                  // }
                },
              },
              data: this.unSecurity,
            },
            {
              name: '已完成专项检查',
              type: 'bar',
              stack: 'bar1',
              barGap: '10%',
              barMaxWidth: 25,
              itemStyle: {
                normal: {
                  color: '#0e76f1',
                  barBorderRadius: 0,
                  // label: {
                  //   show: true,
                  //   position: "top",
                  //   textStyle: {
                  //     color: "#333"
                  //   },
                  //   formatter: function(p) {
                  //     return p.value > 0 ? p.value : "";
                  //   }
                  // }
                },
              },
              data: this.doneSpecial,
            },
            {
              name: '平均',
              type: 'line',
              stack: 'bar2',
              symbolSize: 10,
              symbol: 'circle',
              itemStyle: {
                normal: {
                  color: 'rgba(252,230,48,1)',
                  barBorderRadius: 0,
                  label: {
                    show: true,
                    position: 'top',
                    formatter: function(p) {
                      return p.value > 0 ? p.value : '';
                    },
                  },
                },
              },
              data: [],
              markLine: {
                data: [
                  {
                    type: 'average',
                    name: '平均数',
                    label: {
                      normal: {
                        position: 'end',
                        formatter: '{b}: {c}',
                      },
                    },
                  },
                ],
              },
            },
          ],
        };
        option&&this.barEcharsInstance.setOption(option);
      } 
    },
    // 左侧饼图
    getPieEchar(dom) {
      if (dom){
        let legendName = ['完成', '未完成'];
        let ChartTips = '';
        if (!legendName.length) {
          ChartTips = '暂无数据';
        }
        let tempChart = this.$echarts.getInstanceByDom(dom);
        if (tempChart != null) {
          this.pieEchartsInstance.dispose();
        }
        this.pieEchartsInstance = this.$echarts.init(dom);
        let option = {
          backgroundColor: '',
          tooltip: {
            trigger: 'item',
            formatter: '{b} : {d}% <br/> {c}次',
          },
          grid: {
            center: ['50%', '0'],
          },
          graphic: {
            elements: [
              {
                type: 'text',
                style: {
                  text: ChartTips,
                  x: 100,
                  y: 100,
                  textAlign: 'center',
                  fill: '#333333',
                  font: '16px "MicrosoftYaHei", sans-serif ',
                },
                left: 'center',
                top: '30%',
              },
            ],
          },
          legend: {
            orient: 'vertical',
            left: '30%',
            bottom: 0,
            itemWidth: 10,
            itemHeight: 10,
            align: 'left',
            textStyle: {
              fontSize: 14,
              color: '#000',
            },
            data: legendName,
          },
          series: [
            {
              type: 'pie',
              radius: ['65%', '75%'],
              center: ['50%', '40%'],
              color: ['#0f77f2', '#ffb11a'],
              data: this.PieCharData,
              startAngle: 65, //起始角度
              label: {
                show: true,
                formatter: '{c}次',
                textStyle: {
                  fontSize: 12,
                },
                width:48,
                position: 'outside',
                overflow:'truncate',
                emphasis: {
                  show: true,
                },
              },
              labelLayout: {
                align:'left'
              },
              labelLine: {
                normal: {
                  show: true,
                  length: 6,
                  length2:this.screen?6:3,
                },
              },
            },
          ],
        };
        option&&this.pieEchartsInstance.setOption(option);
        this.pieEchartsInstance.on('click', (par) => {
          this.$router.push({
            path: '/SafeProductionCheckList',
          });
        });
      } 
    },
    initScreen(){
      //获取当前分辨率
      this.screen = window.innerWidth;
      if (this.screen >= 1480) {
        this.screen = true;
      } else {
        this.screen = false;
      }
    }
  },
};
</script>

<style lang="scss">
.SecurityCheck {
  background: #fff;
  padding-left: 6px;
  .container {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    // height: 380px;
    padding: 10px 20px 20px 20px;
    overflow: auto;
    .left-part {
      width: 50%;
      height: 100%;
      min-width: 405px;
      .content {
        margin-bottom: 26px;
        .echarsDemo {
          height: 220px;
          width:calc(35% - 12px);
          min-width: 130px;
        }
        .contentInfo {
          width: 65%;
          min-width: 263px;
          min-height: 140px;
          padding: 15px 0;
          .title {
            font-weight: 600;
            border-left: 4px solid #0f77f2;
            padding-left: 8px;
            cursor: pointer;
            &:hover {
              color: #0e76f1;
              transition: all 0.3s;
            }
          }
          .line {
            line-height: 1.6;
          }
          .ft-wet {
            font-weight: 600;
            line-height: 1.6;
            word-break: break-word;
          }
          .info-item {
            margin-top: 20px;
          }
        }
      }
      .footer {
        height: 70px;
        margin: 0 10px;
        border-top: 1px solid #e2e2e2;
        .col-gre {
          color: #7cc562;
        }
        & > div {
          height: 35px;
        }
        .footer-label {
          margin-right: 10px;
        }
        .footer-item {
          width: 200px;
          margin: 0 10px;
        }
        .el-progress-bar__innerText {
          color: #333;
        }
      }
    }
    .right-part {
      width: 50%;
      height: 100%;
      min-width: 405px;
      .ub {
        flex-wrap: inherit;
      }
      .col-b {
        color: #0e76f1;
      }
      .barEchars {
        height: 280px;
        flex: 1;
        min-width: 263px;
        width: 65%;
        margin: 0 auto;
      }
      .pieEcharts {
        height: 220px;
        min-width: 130px;
        width:calc(35% - 12px);
        margin-right: 12px;
      }
    }
  }
}
.el-progress-bar{
  min-width: 15px;
}
</style>
